<template>
  <span class="inline-flex h-6">
    <NuxtImg
      src="/logo/text/blue.webp"
      alt="mychar logo"
      class="logo-light h-full w-auto"
      width="97"
      height="24"
    />
    <NuxtImg
      src="/logo/text/beige.webp"
      alt="mychar logo"
      class="logo-dark h-full w-auto"
      width="97"
      height="24"
    />
  </span>
</template>

<style scoped>
.logo-dark {
  display: none;
}

.dark .logo-dark {
  display: block;
}

.dark .logo-light {
  display: none;
}
</style>
